// angular imports
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';

// cc-common imports
import { Utils } from 'cc-common';

// 3rd party imports
import { cloneDeep } from 'lodash';

// devextreme imports
import { DxDataGridComponent } from 'devextreme-angular';

// constant imports
import { ActionConstants } from '../../../../_constants/action-constants';

// component imports
import { WorkOrderBaseComponent } from '../../../_base/work-order-base-component';

// model imports
import { WorkOrderLineItemRawDto } from '../../../_models/work-order-line-item-raw-dto';
import { WorkOrderRawDto } from '../../../_models/work-order-raw-dto';
import { WorkOrderEditorResultDto } from '../../../_models/work-order-editor-result-dto';

@Component({
    selector: 'app-work-order-editor-job-detail',
    templateUrl: './work-order-editor-job-detail.component.html',
    styleUrls: ['./work-order-editor-job-detail.component.scss']
})
export class WorkOrderEditorJobDetailComponent extends WorkOrderBaseComponent implements OnInit {
    @ViewChild('lineItemGrid', { static: false }) lineItemGrid: DxDataGridComponent;
    @Input() workOrderEditor: WorkOrderEditorResultDto;
    @Input() workOrderInfo: WorkOrderRawDto;

    originalLineItems: Array<WorkOrderLineItemRawDto> = [];

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        this.originalLineItems = cloneDeep(this.workOrderInfo.lineItems);
    }

    onEditorContentReady(event): void {
        event.component.filter(['crudAction', '<>', ActionConstants.DELETE]);
    }

    onRowUpdated(event): void {
        if (Utils.isNullOrUndefined(event.data.crudAction)) {
            event.data.crudAction = ActionConstants.EDIT;
        }
    }

    onDeleteClick(record: WorkOrderLineItemRawDto): void {
        record.crudAction = ActionConstants.DELETE;

        const originalLineItem = this.originalLineItems.find((d) =>
            Utils.equals(d.workOrderItemId, record.workOrderItemId)
        );
        if (Utils.notNullAndDefined(originalLineItem)) {
            record.description = originalLineItem.description;
            record.serviceCode = originalLineItem.serviceCode;
            record.amount = originalLineItem.amount;
        }

        this.lineItemGrid.instance.filter(['crudAction', '<>', ActionConstants.DELETE]);
        this.lineItemGrid.instance.refresh();
    }

    onAddLineItemClick(): void {
        const defaulServiceCodeItem = this.workOrderEditor.serviceCodeList.find((d) => Utils.isTrue(d.isDefault));
        const newLineItem: WorkOrderLineItemRawDto = new WorkOrderLineItemRawDto();

        newLineItem.id = this.workOrderInfo.lineItems.length + 1;
        newLineItem.crudAction = ActionConstants.ADD;
        newLineItem.serviceCode = Utils.notNullAndDefined(defaulServiceCodeItem) ? defaulServiceCodeItem.key : null;
        this.workOrderInfo.lineItems.push(newLineItem);

        this.lineItemGrid.instance.repaint();
    }
}
